export enum EDashboardWorkflow {
  DRAFT = 'draft',
  APPROVAL = 'approval',
  OTHER_NOT_APPROVED = 'other-not-approved',
  APPROVED = 'approved',
}

export enum EDashboardReviewState {
  OVERDUE = 'overdue',
  DUE_SOON = 'due-soon',
  SCHEDULED = 'scheduled',
  NOT_CONFIGURED = 'not-configured',
}
